import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from '../../login/login.service';
import { CostCentersService } from '../_services/costsCenters.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { CostsCentersDetailComponent } from '../costs-centers-detail/costs-centers-detail.component';

@Component({
    selector: 'app-costs-centers-list',
    templateUrl: './costs-centers-list.component.html',
    styleUrls: ['./costs-centers-list.component.css'],
    host: { class: 'list-page' },
    standalone: false
})
export class CostsCentersListComponent implements OnInit {
 public costsCenters: any = [];
    public totalRecords: number = 0;
    public loading: boolean = false;
    private lastGridEvent: any = {
      first: 0,
      rows: 10
    };
    public filters: any = {
      name: new Filter(FilterOperation.contains, 'name'),
      code: new Filter(FilterOperation.contains, 'code'),
    };

    public fieldsConfig: FilterFieldConfig[] = [
      { filter: this.filters.code, type: 'text', label: 'Código', base: true },
      { filter: this.filters.name, type: 'text', label: 'Nombre', base: true }
    ];
    public allowWrite: boolean = false;
    public allowDelete: boolean = false;
    public type: string = "";

  constructor(
    private messageService: MessageService,    
        private confirmationService: ConfirmationService,                
        private topbarService: TopbarService,
        private costCentersService: CostCentersService,
        private route: ActivatedRoute,
        private dialogService: DialogService,
        private loginService: LoginService
  ) { }

  ngOnInit() {
     this.route.paramMap.subscribe((params: ParamMap) => {      
        this.topbarService.setTitle("Centros de coste");   
        this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
          this.edit(null);
        });
        //this.loadData(this.lastGridEvent);
      });
      this.allowWrite = this.loginService.hasPermission("COSTS_CENTERS.WRITE");
      this.allowDelete = this.loginService.hasPermission("COSTS_CENTERS.DELETE");
      
  }


    async loadData($event: any) {
        
        this.lastGridEvent = $event;  
        let params:IParamsCollection = {      
          page: { number: $event.first+1, size: $event.rows },            
          filter: FilterBuilder.fromObject(this.filters).build()
        }            
        
        if(typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];  
        let response = await firstValueFrom(this.costCentersService.all(params));
        this.costsCenters = response.data;
        this.totalRecords = response.meta['total'];
        this.topbarService.setCount(this.totalRecords);
      }
      
      clearFilters() {
        this.filters = {};
        this.search();
      }
    
      search() {
        this.lastGridEvent.first = 0;
        this.loadData(this.lastGridEvent);
      }
    
        edit(id: any) {
          const ref = this.dialogService.open(CostsCentersDetailComponent, {
            closable: true,
            modal: true,
            data: {
              id: id ? id : null
            },
            header: id ? "Modificar el centro de coste" : "Nuevo centro de coste",
            width: '40%'
          });
          ref.onClose.subscribe((data: any) => {
            this.loadData(this.lastGridEvent);
          });
        }
    
        delete(costCenter: any) {    
          if (this.allowDelete) {      
            this.confirmationService.confirm({
              message: "¿Está seguro que desea eliminar el centro de coste "+costCenter.name+"?",
              header: "Eliminar centro de coste",
              acceptLabel: "Aceptar",
              rejectLabel: "Cancelar",
              acceptButtonStyleClass: "p-button-danger",
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                this.costCentersService.delete(costCenter.id).subscribe({
                  next: (data: any) => {
                    this.messageService.add({ closable: true, severity: 'success', detail: "Centro de coste eliminado correctamente" });
                    this.loadData(this.lastGridEvent);
                  },
                  error: (error: any) => {
                    this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
                  }
                });
              },
              reject: (error: any) => {
                this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
              }
            });
          }
        }
        

}
